import { default as React } from 'react';
import { IFormValidationProperties } from '../../model/forms';
import { IFieldBaseProperties, IFieldValueProperties, IFieldEvent, IValidationProperties } from './interfaces';
import TextField from './TextField';

const phoneNumberRegEx = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

interface IPhoneNumberProperties extends IFieldBaseProperties, IFieldValueProperties, IFormValidationProperties, IValidationProperties {
  country?: string;
}

function Validate(phoneNumber?: string, required: boolean = false) : [valid: boolean, message?: string] {
  if (required && (phoneNumber === undefined || phoneNumber.trim().length === 0)) {
    return [false, "Phone number is required"];
  }

  if (phoneNumber === undefined || phoneNumber.trim().length === 0) {
    return [true, undefined];
  }

  let result = phoneNumberRegEx.test(phoneNumber);
  return result === true ? [ true, undefined ] : [ false, "You must provide a valid phone number"];
}

export default class PhoneNumberField extends React.PureComponent<IPhoneNumberProperties> {
  constructor(props: IPhoneNumberProperties) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(event: IFieldEvent) {
    if (this.props.onChange !== undefined) {
      this.props.onChange(event);
    }
  }

  componentDidUpdate(prevProps: IPhoneNumberProperties) {
    if (prevProps.value !== this.props.value) {
      //Trigger re-validate      
      let [ valid, message ] = Validate(this.props.value, this.props.required);
      if (this.props.onValidate !== undefined) {        
        this.props.onValidate({
          name: this.props.id,
          result: valid,
          message: message
        });
      }
    }
  }

  public render() {
    return <TextField {...this.props} valid={this.props.valid} message={this.props.message} />
  }
}